"use client";

import { c as _c } from "react/compiler-runtime";
import React, { createContext, useContext, useState, useCallback } from "react";
import SwiperModal from "./SwiperModal";
const ModalContext = createContext();
export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModal must be used within a ModalProvider");
  }
  return context;
};
export const ModalProvider = t0 => {
  const $ = _c(13);
  const {
    children
  } = t0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [initialSlideIndex, setInitialSlideIndex] = useState(null);
  const [projectImages, setProjectImages] = useState(null);
  const [digitalProfile, setDigitalProfile] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = t2 => {
      const slideIndexOrImageId = t2 === undefined ? 0 : t2;
      setInitialSlideIndex(slideIndexOrImageId);
      setIsModalOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const openModal = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsModalOpen(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const closeModal = t2;
  let t3;
  if ($[2] !== isModalOpen) {
    t3 = {
      isModalOpen,
      openModal,
      closeModal,
      setProjectImages,
      setDigitalProfile
    };
    $[2] = isModalOpen;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const value = t3;
  let t4;
  if ($[4] !== digitalProfile || $[5] !== initialSlideIndex || $[6] !== isModalOpen || $[7] !== projectImages) {
    t4 = isModalOpen && <SwiperModal isOpen={isModalOpen} onClose={closeModal} initialSlideIndex={initialSlideIndex} projectImages={projectImages} digitalProfile={digitalProfile} />;
    $[4] = digitalProfile;
    $[5] = initialSlideIndex;
    $[6] = isModalOpen;
    $[7] = projectImages;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== children || $[10] !== t4 || $[11] !== value) {
    t5 = <ModalContext.Provider value={value}>{children}{t4}</ModalContext.Provider>;
    $[9] = children;
    $[10] = t4;
    $[11] = value;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};